import React from 'react';
import { Card, CardContent } from 'components/ui/card';
import { StatusBadge } from 'components/StatusBadge';
import { Avatar, AvatarFallback } from 'components/ui/avatar';
import { ArrowRight, MapPin } from 'lucide-react';
import { formatPrice, formatDate } from 'lib/format';
import { Link } from 'react-router-dom';
import { useLanguage } from 'lib/i18n';

export const MissionCard = ({ mission, isDeliverer }) => {
  const { t } = useLanguage();
  const otherName = isDeliverer ? mission.sender_name : mission.deliverer_name;
  return (
    <Card className="hover:shadow-md-custom transition-shadow duration-200" data-testid={`mission-card-${mission.id}`}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-center gap-2">
            <Avatar className="h-9 w-9">
              <AvatarFallback className="bg-secondary text-xs">
                {(otherName || 'U').split(' ').map(n => n[0]).slice(0, 2).join('')}
              </AvatarFallback>
            </Avatar>
            <div>
              <div className="text-sm font-medium">{otherName || t('card.user')}</div>
              <div className="text-xs text-muted-foreground">{formatDate(mission.created_at)}</div>
            </div>
          </div>
          <StatusBadge status={mission.status} />
        </div>

        <div className="flex items-center justify-between mb-3">
          <div className="text-lg font-semibold text-primary">{formatPrice(mission.proposed_price)}</div>
        </div>

        <Link to={`/missions/${mission.id}`} className="text-xs font-medium text-primary hover:underline inline-flex items-center gap-1" data-testid={`mission-card-open-${mission.id}`}>
          {t('card.open')} <ArrowRight size={12} />
        </Link>
      </CardContent>
    </Card>
  );
};
